import { Box, Flex, Text } from '@fundamentals'
import type { ReactNode } from 'react'

export const RegisterInspectionCardDetailRow = ({
  label,
  value,
}: {
  label: string
  value: ReactNode
}) => (
  <Flex alignItems='center'>
    <Box flex={1} sx={{ minWidth: 0 }}>
      <Text color='text.secondary' variant='body2'>
        {label}
      </Text>
    </Box>
    <Box flex={2} minWidth={0}>
      {typeof value === 'string' || typeof value === 'number' ? (
        <Text variant='body2'>{value}</Text>
      ) : (
        value
      )}
    </Box>
  </Flex>
)
